module.exports = __webpack_public_path__ + "static/media/recovery-iconography.cf7e68fc.png";